@if (hasTooltip()) {
    <div #reference>
        <ng-container [ngTemplateOutlet]="tplChip"></ng-container>
        <bazis-tooltip
            [reference]="reference"
            [eventType]="'hover'"
            [placement]="tooltipPlacement()"
            [isStatic]="isStaticTooltip()"
            [offset]="tooltipOffset()"
            class="bh-popper-z-index"
        >
            {{ tooltipText() || label() }}
        </bazis-tooltip>
    </div>
} @else {
    <div>
        <ng-container [ngTemplateOutlet]="tplChip"></ng-container>
    </div>
}

<ng-template #tplChip>
    <bazis-chip
        class="bazis-status"
        [class.bazis-status_only-icon]="!label()"
        [color]="color() ? color() : ''"
        [size]="size()"
        [fill]="fill()"
    >
        @if (iconStart()) {
            <bazis-icon [icon]="iconStart()"></bazis-icon>
        }
        @if (label()) {
            <span>{{ label() }}</span>
        }
        @if (iconEnd()) {
            <bazis-icon [icon]="iconEnd()"></bazis-icon>
        }
    </bazis-chip>
</ng-template>
